/**
 * The roster + admission decision a provider is constructed with, and the
 * snapshot it starts from. Provider-agnostic: both the simulator and the
 * LiveKit client begin here, so a swap changes no observable initial state.
 */
import type { QualityProfile } from '@cyphex/types';
import type { MediaParticipant, MediaSnapshot, RecordingState } from './contract';
import { resolveShareOwner } from './shareArbiter';
import { IDLE_PROCESSING_STATUS } from './settings/preferences';

export interface MediaRoomSeed {
  /** SFU identity of this session, as minted by apps/api. */
  readonly localId: string;
  readonly participants: readonly MediaParticipant[];
  readonly profile: QualityProfile;
  readonly recording: RecordingState;
  readonly recordingStartedBy: string | null;
}

export function initialSnapshot(seed: MediaRoomSeed): MediaSnapshot {
  return {
    state: 'idle',
    participants: seed.participants,
    activeSpeakerIds: [],
    localId: seed.localId,
    /* The arbiter here too, so the pre-connect snapshot cannot name a different
       presenter from the one the room settles on a moment later. */
    screenShareOwnerId: resolveShareOwner(seed.participants),
    shareStopped: null,
    /* Nothing has been captured before a room exists. */
    shareCapturing: false,
    quality: 'excellent',
    profile: seed.profile,
    recording: seed.recording,
    recordingStartedBy: seed.recordingStartedBy,
    downlinkBps: 0,
    packetLoss: 0,
    processing: IDLE_PROCESSING_STATUS,
  };
}
